import type { ChatRequest } from '../types/chat';

/**
 * Build the wire payload for the `chatWithPlant` callable.
 *
 * The Firebase callable client does NOT drop keys whose value is `undefined` —
 * `@firebase/functions` `encode()` starts with `if (data == null) return null`
 * and applies that over every own key, so an "omitted" optional field arrives
 * at the Cloud Function as an explicit JSON `null`. General-mode chat (the
 * Ask Expert sheet on PlantDetail) passes `diagnosisContext: undefined`, which
 * reached the server as `null` and failed the whole request.
 *
 * Only include `diagnosisContext` when there actually is one.
 *
 * Lives in its own module (not `api.ts`) so tests can import it without
 * triggering Firebase app initialization.
 */
export function buildChatPayload(request: ChatRequest): ChatRequest {
  return {
    plantContext: request.plantContext,
    messages: request.messages,
    ...(request.diagnosisContext ? { diagnosisContext: request.diagnosisContext } : {}),
  };
}
